import * as component from "./component";

export default component;
